<template>
  <div id="idverify_view_outer" v-if="verifyModel != null">
    <div id="user_id_check_view">
      <div class="input-row">
        <div class="column left-label">*姓名：</div>
        <div class="column">{{verifyModel.name}}</div>
      </div>
      <div class="input-row">
        <div class="column left-label">*证件号码：</div>
        <div class="column">{{verifyModel.idNo}}</div>
      </div>
      <div style="text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">

        <div v-show="verifyModel != null && verifyModel.isIdentification > 0" style="height: 80px;line-height: 80px;">
          <span v-if="!isIdVerifiedError" style="color: green;"><span class="iconfont" style="margin-right:10px;font-weight: bold;">&#xe654;</span>实名认证已通过</span>
          <span v-else style="color:#fc1a34;"><span class="iconfont" style="margin-right:10px;">&#xe62b;</span>实名认证失败</span>
        </div>

        <el-button v-if="verifyModel != null && verifyModel.isIdentification > 0" class="next-button" @click="nextButtonClicked" round>{{nextButtonText}}</el-button>
        <el-button v-else-if="!isIdVerifiedError" class="next-button" @click="realNameVerifyClicked" round>开始实名认证</el-button>
        <el-button v-else class="next-button" @click="realNameVerifyClicked" round>重新实名认证</el-button>
        <el-button v-if="isIdVerifiedError" class="cancel-button" @click="cancelButtonClicked" round>返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import EventManager from "../../js/event-common";
  import HardwareManager from "../../js/hardware-check.js";
  var aliGetMetaInfo = getMetaInfo;
  export default {
    name: "IdentificationVerificationVue",
    props: {
      nextButtonText: {
        default: ()=>"下一步",
      },
      name: {
        default: ()=> null,
      },
      idNo: {
        default: () => null,
      }
    },
    data() {
      return {
        isIdVerifiedError: false,
        verifyModel: null,
        isSupportedCamera: null,
      }
    },

    computed: {
      user() {
        return this.$store.state.user;
      },
      httpManager() {
        return this.$store.state.http;
      },
      eventManager() {
        return this.$store.state.eventManager;
      },
    },
    mounted() {
      let _this = this;
      HardwareManager.isSupportCamera(function(isSupported) {
        _this.isSupportedCamera = isSupported;
      });
      this.initData();
      this.initWithUrl();
      this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
    },
    methods: {
      initData() {
        let user = this.user;
        if (user == null) {
          let _this = this;
          setTimeout(function () {
            _this.initData();
          }, 50);
          return;
        }

        let userName = user.name;
        let userIdNo = user.idNumber;
        let name = null;
        let idNo = null;
        if (this.name != null && this.name != '' && this.idNo != null && this.name != '') {
          name = this.name;
          idNo = this.idNo;
        }
        let model = {};
        if (name == null) {
          model.name = userName;
          model.idNo = userIdNo;
		  model.isIdentification = 0;
        } else {
			model.name = name;
			model.idNo = idNo;
          if (userName == name && userIdNo == idNo) {
            if (user.isIdentification > 0) { // 已实名认证
              this.$emit("userHasVerified");
            }
			model.isIdentification = user.isIdentification;
          } else {
			model.isIdentification = 0;
		  }
        }
        this.verifyModel = model;
      },

      initWithUrl() {
        let query = this.$route.query;
        let response = query.response;
        if (response != null) {
          let dataStr = decodeURI(response);
          response = JSON.parse(dataStr);
          let certifyId = response.extInfo.certifyId;
          let params = this.$route.params;
          let name = this.$route.name;
          this.$router.push({
            name,
            params,
            query: {}
          });
          this.updateRealNameState(certifyId);
        }
      },

      realNameVerifyClicked() {
        let isSupportedCamera = this.isSupportedCamera;
        if (isSupportedCamera == null) {
          let _this = this;
          setTimeout(function() {
            _this.realNameVerifyClicked();
          },100);
          return;
        }

        if (isSupportedCamera == false) {
          this.$confirm("该认证需要人脸识别，检测到您的设备未安装或开启摄像头，请开启或更换设备后重试。");
          return;
        }

        let metaInfo = aliGetMetaInfo();
        if (metaInfo == null) {
          return;
        }
        let model = this.verifyModel;
        console.log(model);
        let metaInfoStr = JSON.stringify(metaInfo);
        let url = window.location.href;
        let params = {
          certName: model.name,
          certNo: model.idNo,
          metaInfo: metaInfoStr,
          returnUrl: encodeURI(url),
        };

        let _this = this;
        this.httpManager.ajax.postUserFaceVerifyInitData(params, function (data) {
          let code = data.code;
          if (code == 0) {
            let returnData = data.data;
            let certifyUrl = returnData.certifyUrl;
            let certifyId = returnData.certifyId;
            if (certifyUrl != null) {
              window.open(certifyUrl, '_self');
              return;
            }
            let errorMsg = '您的姓名与身份证号不匹配，请修改后重新提交。';
            _this.isIdVerifiedError = true;
            _this.dealWithErrorMsg(errorMsg);
          } else {
            _this.$toast('请求失败');
          }
        }, function (data) {
          _this.$toast('请求失败，请重试');
        });
      },

      dealWithErrorMsg(errorMsg) {
        this.$toast(errorMsg);
        this.$store.commit('setIdErrorRemark', errorMsg);
      },

      updateRealNameState(certifyId) {
        let model = this.verifyModel;
        let params = {
          certifyId,
          name: model.name,
          idNo: model.idNo,
        };
        let _this = this;
        this.httpManager.ajax.getUserDescribeFaceVerifyData(params, function (data) {
          let code = data.code;
          _this.dealWithRealNameData(code);

        }, function (data) {
          _this.$toast('认证失败，请重试！');
        });
      },

      dealWithRealNameData(subCode) {
        if (subCode == 200 || subCode == 210) { // 认证成功;
          let user = this.user;
          user.name = this.verifyModel.name;
          user.idNumber = this.verifyModel.idNo;
          user.isIdentification = 1;
          this.verifyModel.isIdentification = 1;
          this.$store.commit("setUser", user);
        } else {
          this.isIdVerifiedError = true;
          let errorMsg = '';
          switch (subCode) {
            case 201: // shenz
              errorMsg = "您的姓名与身份证号不匹配，请修改后重新提交。";
              break;
            case 202:
              errorMsg ="查询不到身份信息";
              break;
            case 203:
              errorMsg = "查询不到照片或照片不可用";
              break;
            case 204:
              errorMsg = "人脸比对不一致";
              break;
            case 205:
              errorMsg = "活体检测存在风险";
              break;
            default:
              errorMsg = "认证失败！";
          }
          this.dealWithErrorMsg(errorMsg);
        }
      },

      cancelButtonClicked() {
        this.$store.commit("isAllowedLeave", true);
        this.$emit("backToEditPage");
      },

    nextButtonClicked() {
		let model = this.verifyModel;
		this.$emit("next-step");
      }
    }
  }
</script>

<style scoped>
  #idverify_view_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  #idverify_view_outer > div {
    width: 100%;
    margin-top: 30px;
  }

  #idverify_view_outer .input-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
  }

  #idverify_view_outer .input-row:last-child {
    margin-bottom: 0;
  }

  #idverify_view_outer .input-row > .column:first-child {
    width: 50%;
    text-align: right;
    padding-right: 10px;
  }

  #idverify_view_outer .input-row > .column:not(:first-child) {
    width: 50%;
    padding-left: 10px;
  }


  #idverify_view_outer .left-label {
    font-size: small;
  }

  #idverify_view_outer .next-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 90%;
    max-width: 300px;
    padding-left: 0;
    padding-right: 0;
    color: white;
    margin-top: 40px;
    margin-bottom: 15px;
  }

  #idverify_view_outer .cancel-button {
    width: 90%;
    max-width: 300px;
    margin-bottom: 20px;
    border-color: lightgrey;
    background-color: white;
    color: #666;
  }


  .files-upload {
    margin-top: 15px;
    text-align: left;
  }

  #idverify_view_outer .files-upload /deep/ .el-upload-list__item, #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
    line-height: 100px;
  }

  #idverify_view_outer .files-upload /deep/ input[type='file'] {
    display: none;
  }

  #idverify_view_outer .files-upload /deep/ .el-button {
    background-color: #fc1a34;
    color: white;
    border: none;
    margin-top: 10px;
  }


  #idverify_view_outer .files-upload /deep/ .el-upload__tip {
    margin-top: 15px;
  }

  @media screen and (min-width: 768px){
    #idverify_view_outer > div {
      max-width: 700px;
    }

    #idverify_view_outer .left-label {
      font-size: 1rem;
    }

    #idverify_view_outer .files-upload /deep/ .el-upload-list__item, #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
      width: 140px;
      height: 140px;
    }

    #idverify_view_outer .files-upload /deep/ .el-upload--picture-card {
      line-height: 140px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/common/IdentificationVerificationVue.vue